<template>
  <v-form ref="form" v-bind="this.$attrs">
    <p class="font-weight-black black--text">5. Tổ trưởng, nhóm trưởng</p>
    <v-row class="pr-12">
      <v-col class="d-flex align-center py-0" cols="12" v-for="key in renderKeys" :key="key">
        <v-subheader class="py-0 px-0">{{ getTitle(key) }}</v-subheader>
        <p class="mb-0">{{ getSubjectGroupTitle(key) }}</p>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import { SubjectGroup, AcademicLevel } from '@/plugins/api'
import { get } from 'lodash'

export default {
  computed: {
    ...mapState('teacher', ['teacher'])
  },
  data() {
    return { subjectGroups: [], subjectGroupConfig: {}, renderKeys: [], get }
  },
  async mounted() {
    await this.fetchAllSubjectGroups()
    await this.initData()
  },
  methods: {
    getAcademicLevel(level = '') {
      switch (level) {
        case 'primary':
          return 'Cấp Tiểu Học'
        case 'secondary':
          return 'Cấp THCS'
        case 'high':
          return 'Cấp THPT'
        default:
          return ''
      }
    },
    getTitle(key = '') {
      const keyParts = key.split('_')
      const config = keyParts[0]
      const level = keyParts[2]
      const prefix = config === 'leader' ? 'Tổ trưởng' : 'Nhóm trưởng'
      const postfix = this.getAcademicLevel(level)
      return prefix + ' ' + postfix
    },
    async fetchAllSubjectGroups() {
      this.subjectGroups = await SubjectGroup.fetch({
        _limit: -1,
        _sort: 'index:ASC'
      })
    },
    async initData() {
      const activeLevels = await AcademicLevel.fetch({ status: 'active' })
      if (Array.isArray(activeLevels) && activeLevels.length) {
        activeLevels.forEach(x => {
          this.subjectGroupConfig[`leader_${x.id}_${x.type}`] = ''
          this.subjectGroupConfig[`subLeader_${x.id}_${x.type}`] = ''
        })
      }
      this.renderKeys = Object.keys(this.subjectGroupConfig).sort((a, b) => a - b)
    },
    getSubjectGroupTitle(key = '') {
      const id = get(this.teacher, `data.subjectGroupConfig.${key}`, '')
      const subjectGroup = this.subjectGroups.find(x => x.id === id)
      if (subjectGroup) return subjectGroup.title
      return ''
    }
  }
}
</script>

<style scoped>
.v-subheader {
  width: 30%;
}
p {
  color: black;
}
.p > .v-input__control > .v-input__slot:before {
  border-style: none;
}
</style>
